import './styles.scss'
import React from 'react'
import { I18n } from 'react-redux-i18n'

import ConfigContainer from './ConfigContainer'
import SentimentAnalysisSwitch from './SentimentAnalysisSwitch'
import AutomaticAssignmentSwitch from './AutomaticAssignmentSwitch'
import { Button } from 'components/Form'
import { ALLOWED_DOMAINS } from 'constants/index'
import AutomationInactiveOperators from './AutomationInactiveOperators'

const MessagesConfigViewUI = ({
  company, configurations, onChange,
  handleSave, isSaving, isDisabledSave
}) => (
  <div className='messages-view animated fadeIn'>
    <div className='messages-view__header'>
      <h1>{I18n.t('dashboard_messages-and-conversations')}</h1>
      <strong>{I18n.t('configuration_messages_title')}</strong>
    </div>
    <div className='messages-view__body'>
      <ConfigContainer
        title
        subtitle
        company={company}
        tag='welcome'
        fields={['message']}
        onChange={value => onChange({ tag: 'welcome', value })}
      />
      <ConfigContainer
        title
        subtitle
        company={company}
        tag='reWelcome'
        fields={['message', 'timer']}
        onChange={value => onChange({ tag: 'reWelcome', value })}
      />
      <ConfigContainer
        title
        subtitle
        company={company}
        tag='paymentOk'
        fields={['message']}
        onChange={value => onChange({ tag: 'paymentOk', value })}
      />
      <ConfigContainer
        title
        subtitle
        company={company}
        tag='outOfOffice'
        fields={['message', 'timer', 'schedule']}
        onChange={value => onChange({ tag: 'outOfOffice', value })}
      />
      <ConfigContainer
        title
        subtitle
        company={company}
        tag='clickToCall'
        fields={['message']}
        onChange={value => onChange({ tag: 'clickToCall', value })}
      />
      {ALLOWED_DOMAINS.type === 'TA' ? (
        <ConfigContainer
          title
          company={company}
          tag='refundAutomatic'
          fields={['schedule']}
          onChange={value => onChange({ tag: 'refundAutomatic', value })}
        />
      ): null}
      {ALLOWED_DOMAINS.type === 'TA' ? (
        <ConfigContainer
          title
          company={company}
          tag='nightTime'
          fields={['schedule']}
          onChange={value => onChange({ tag: 'nightTime', value })}
        />
      ) : null}
      <ConfigContainer
        title
        company={company}
        tag='users'
        fields={['activation', 'unassignOperators', 'multipleSelector', 'timer', 'singleSelector']}
        configurations={configurations}
        onChange={value => onChange({ tag: 'users', value })}
      />
      <ConfigContainer
        title
        company={company}
        tag='operators'
        fields={['timer']}
        configurations={configurations}
        onChange={value => onChange({ tag: 'operators', value })}
      />
      <AutomationInactiveOperators />
      <SentimentAnalysisSwitch />
      <AutomaticAssignmentSwitch />
    </div>
    <div className='messages-view__footer'>
      <Button
        secondary
        value={I18n.t('dashboard_save')}
        onClick={handleSave}
        isSubmitting={isSaving}
        disabled={isDisabledSave}
      />
    </div>
  </div>
)

export default MessagesConfigViewUI
